import { Box, Button, Skeleton, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import ProjectParticipantCard from './ProjectParticipantCard';
import { ExoSkeleton } from '../ExoSkeleton';
import { TypeParticipantsAutoComplete } from '../../form/form-fields/TypeParticipantsAutoComplete';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';
import Loader from '../../special/Loader';
import { useEffect, useState } from 'react';

const ProjectParticipantsList = ({
  participants,
  project,
  onProjectChange,
  editmode,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const [dataCollection, setDataCollection] = useState({});

  useEffect(() => {
    setDataCollection({ participants });
  }, [participants]);

  function updateProject(key, participants) {
    setDataCollection({ [key]: participants });
    DBRequest({
      config,
      path: `projects/${project.id}`,
      method: API_PATCH({ participants }),
      onResponse: onProjectChange,
      onLoading: setIsLoading,
    });
  }

  if (!participants)
    return (
      <Box className="overflow-y-auto max-h-[500px] xl:max-h-[9999px] xl:h-full flex flex-col gap-1">
        <ExoSkeleton size="115px" n={5} />
      </Box>
    );

  return (
    <Box className={'flex flex-col gap-2 overflow-y-auto h-full pr-2 '}>
      <Loader active={isLoading} />
      {editmode ? (
        <Box className={' flex rounded-lg '}>
          <TypeParticipantsAutoComplete
            dataCollection={dataCollection}
            field={{
              label: t('Project Participants'),
              key: 'participants',
              hideEmail: true,
              searchParams: ['person_leads', 'company_leads'],
            }}
            updateValidationOnChange={updateProject}
            errors={{}}
          />
        </Box>
      ) : (
        <>
          {participants.map((participantData) => (
            <ProjectParticipantCard
              key={participantData.id}
              participantData={participantData}
            />
          ))}
        </>
      )}
    </Box>
  );
};

export default ProjectParticipantsList;
